<template>
  <div id="search" class="home">
    <el-container>          
      <div class="content-wrap"  style="min-height:81vh;">
        <div class="condition"  v-loading="resultsLoading">         
          <el-row class="condition-row">
            <el-col :span="3">
              <span class="condition-checked condition-head">已选择条件:</span>              
            </el-col>
            <el-col :span="21">
              <div class="condition-checked"><el-tag size="medium" effect="dark" type="primary">{{city}}</el-tag></div>
              <div class="condition-checked"><el-tag size="medium" effect="dark" type="primary">{{industry}}</el-tag></div>
              <div class="condition-checked"><el-tag size="medium" effect="dark" type="primary">{{property}}</el-tag></div>
              <div class="condition-checked"><el-tag size="medium" effect="dark" type="primary">{{post}}</el-tag></div>              
            </el-col>
          </el-row>
          <el-row class="condition-row">
            <el-col :span="3">
              <span class="condition-checked condition-head">城市:</span>                                         
            </el-col>
            <el-col :span="21">
              <div class="condition-checked" v-for="(item,index) in citys" :key="index">
                <el-dropdown>
                  <span class="el-dropdown-link">
                    {{item.name}}<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="selectCity(indus.name)"  v-for="(indus,idx) in item.children" :key="idx">{{indus.name}}</el-dropdown-item>                    
                  </el-dropdown-menu>            
                </el-dropdown>
              </div>
            </el-col>
          </el-row>          
          <el-row class="condition-row">
            <el-col :span="3">
              <span class="condition-checked condition-head">细分行业:</span>                                          
            </el-col>
            <el-col :span="21">
              <span class="condition-checked" v-for="(item,index) in industrys" :key="index">
                <el-dropdown>
                  <span class="el-dropdown-link">
                    {{item.name}}<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="selectIndustry(indus.name)"  v-for="(indus,idx) in item.children" :key="idx">{{indus.name}}</el-dropdown-item>                    
                  </el-dropdown-menu>
                </el-dropdown>
              </span>
            </el-col>
          </el-row>
          <el-row class="condition-row">
            <el-col :span="3">
              <span class="condition-checked condition-head">企业性质:</span>              
            </el-col>
            <el-col :span="21">
              <div class="condition-checked">
                <el-radio-group v-model="property" @change="selectProperty">
                  <el-radio  label="民营">民营</el-radio>
                  <el-radio  label="国有">国有</el-radio>
                  <el-radio  label="合资">合资</el-radio>
                  <el-radio  label="外资">外资</el-radio>
                  <el-radio  label="全部">全部</el-radio>
                </el-radio-group>
              </div>                          
            </el-col>
          </el-row>          
          <el-row class="condition-row" v-show="showDepts"  v-loading="showDeptsLoading">
            <el-col :span="3">
              <span class="condition-checked condition-head">部门:</span>                                       
            </el-col>
            <el-col :span="21">
              <span class="condition-checked deps" @click="selectPost(dep.dep)" v-for="(dep,index) in deps" :key="index">
                {{dep.dep}}
              </span>
            </el-col>
          </el-row>
          <el-row class="condition-row" v-show="showPosts"  v-loading="showPostsLoading">
            <el-col :span="3">
              <span class="condition-checked condition-head">岗位:</span>                                       
            </el-col>
            <el-col :span="21">
              <span class="condition-checked deps" @click="handleClickPost(post.post)" v-for="(post,index) in posts" :key="index">
                {{post.post}}
              </span>
            </el-col>
          </el-row>
        </div>
        <div v-if="lazyload">
          <div class="results">          
            <div class="analyzeSystem">
              <el-row :gutter="40">
                <el-col :span="12">
                  <el-row>
                    <el-col :span="6" style="text-align:left;color:#8b8d96;font-weight:bold;">
                      <div>职位薪酬收入</div>
                    </el-col>
                    <el-col :span="18" style="text-align:right">
                      <el-dropdown>
                        <el-button type="primary" size="mini">
                          {{ koujing }}<i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item divided @click.native="changeKoujing('月基本收入')">月基本收入</el-dropdown-item>
                          <el-dropdown-item divided @click.native="changeKoujing('月绩效收入')">月绩效收入</el-dropdown-item>
                          <el-dropdown-item divided @click.native="changeKoujing('月总收入')">月总收入</el-dropdown-item>
                          <el-dropdown-item divided @click.native="changeKoujing('年基本收入')">年基本收入</el-dropdown-item>
                          <el-dropdown-item divided @click.native="changeKoujing('年固定收入')">年固定收入</el-dropdown-item>
                          <el-dropdown-item divided @click.native="changeKoujing('年总收入')">年总收入</el-dropdown-item>
                          <el-dropdown-item divided @click.native="changeKoujing('年总成本')">年总成本</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </el-col>
                  </el-row>
                  <div :style="{height:'380px',width:'100%'}" ref="myEchart1"></div>
                </el-col>
                <el-col :span="12">
                  <el-row>
                    <el-col :span="16" style="text-align:left;color:#8b8d96;font-weight:bold;">
                      <div>岗位薪酬地域分布</div>
                    </el-col>
                    <el-col :span="4" style="text-align:right">
                      <el-dropdown>
                        <el-button type="primary" size="mini">
                          {{ aresKoujing }}<i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item divided @click.native="changeareKoujing('月基本收入')">月基本收入</el-dropdown-item>
                          <el-dropdown-item divided @click.native="changeareKoujing('月绩效收入')">月绩效收入</el-dropdown-item>
                          <el-dropdown-item divided @click.native="changeareKoujing('月总收入')">月总收入</el-dropdown-item>
                          <el-dropdown-item divided @click.native="changeareKoujing('年基本收入')">年基本收入</el-dropdown-item>
                          <el-dropdown-item divided @click.native="changeareKoujing('年固定收入')">年固定收入</el-dropdown-item>
                          <el-dropdown-item divided @click.native="changeareKoujing('年总收入')">年总收入</el-dropdown-item>
                          <el-dropdown-item divided @click.native="changeareKoujing('年总成本')">年总成本</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </el-col>
                    <el-col :span="4" style="text-align:right">
                      <el-dropdown>
                        <el-button type="primary" size="mini">
                          {{ aresQuantile }}<i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item divided @click.native="changeQuantile('10%分位')">10%分位</el-dropdown-item>
                          <el-dropdown-item divided @click.native="changeQuantile('25%分位')">25%分位</el-dropdown-item>
                          <el-dropdown-item divided @click.native="changeQuantile('50%分位')">50%分位</el-dropdown-item>
                          <el-dropdown-item divided @click.native="changeQuantile('75%分位')">75%分位</el-dropdown-item>
                          <el-dropdown-item divided @click.native="changeQuantile('90%分位')">90%分位</el-dropdown-item>                          
                        </el-dropdown-menu>
                      </el-dropdown>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24" style="text-align:center">
                      <div :style="{height:'340px',width:'100%'}" ref="aresChart"></div>
                    </el-col>
                  </el-row>
                </el-col>            
              </el-row>
            </div>
          </div>
          <!-- 工作年限图表 -->
          <!-- <div class="results">          
            <div class="analyzeSystem">
              <el-row :gutter="40">
                <el-col :span="12">
                  <el-row>
                    <el-col :span="24" style="text-align:left;color:#8b8d96;font-weight:bold;">
                      <div>职位工作年限分布</div>
                    </el-col>
                  </el-row>
                  <div>
                    <el-row type="flex" class="expirience-item">
                      <el-col :span="4">
                        1年以下
                      </el-col>
                      <el-col :span="16">
                        <el-progress :show-text="false" :stroke-width="6" :percentage="10"></el-progress>
                      </el-col>
                      <el-col :span="4" :offset="1">
                        11%
                      </el-col>
                    </el-row>
                    <el-row type="flex" class="expirience-item">
                      <el-col :span="4">
                        1~3年
                      </el-col>
                      <el-col :span="16">
                        <el-progress :show-text="false" :stroke-width="6" :percentage="20"></el-progress>
                      </el-col>
                      <el-col :span="4"  :offset="1">
                        11%
                      </el-col>
                    </el-row>
                    <el-row type="flex" class="expirience-item">
                      <el-col :span="4">
                        3~5年
                      </el-col>
                      <el-col :span="16">
                        <el-progress :show-text="false" :stroke-width="6" :percentage="50"></el-progress>
                      </el-col>
                      <el-col :span="4"  :offset="1">
                        11%
                      </el-col>
                    </el-row>
                    <el-row type="flex" class="expirience-item">
                      <el-col :span="4">
                        5~10年
                      </el-col>
                      <el-col :span="16">
                        <el-progress :show-text="false" :stroke-width="6" :percentage="10"></el-progress>
                      </el-col>
                      <el-col :span="4"  :offset="1">
                        11%
                      </el-col>
                    </el-row>
                    <el-row type="flex" class="expirience-item">
                      <el-col :span="4">
                        10年以上
                      </el-col>
                      <el-col :span="16">
                        <el-progress :show-text="false" :stroke-width="6" :percentage="10"></el-progress>
                      </el-col>
                      <el-col :span="4"  :offset="1">
                        11%
                      </el-col>
                    </el-row>
                  </div>
                </el-col>
                <el-col :span="12">
                  <el-row>
                    <el-col :span="24" style="text-align:center">
                      <div>
                        <div :style="{height:'300px',width:'100%'}" ref="age"></div>
                      </div>
                    </el-col>
                  </el-row>
                </el-col>            
              </el-row>
            </div>
          </div> -->
          <div class="results">          
            <div class="analyzeSystem">
              <div style="text-align:left;color:#8b8d96;font-weight:bold;padding-bottom:20px;">职位职能、行业薪酬收入</div>
              <el-row>
                <el-col :span="24">
                  <div :style="{height:'400px',width:'100%'}" ref="analyze"></div>
                </el-col>
              </el-row>
            </div>            
          </div>         
          <div class="results">
            <div class="analyzeSystem">
              <div style="text-align:left;color:#8b8d96;font-weight:bold;padding-bottom:20px;">样本报告点击下载</div>
              <el-row :gutter="40" style="text-align:center">
                <el-col :span="6">
                  <img src="../assets/images/regular.png" class="sample-cover" alt="" @click="download('https://taizhicn-com.oss-cn-beijing.aliyuncs.com/download/太智联合薪酬调研报告--线上标准版.docx','线上报告标准版样本报告')">  
                </el-col>
                <el-col :span="6" >
                  <img src="../assets/images/sample-cover-professional.png" class="sample-cover" alt="" @click="download('https://taizhicn-com.oss-cn-beijing.aliyuncs.com/download/太智联合薪酬调研报告--线上专业版.docx','线上报告专业版样本报告')">                  
                </el-col>
                <el-col :span="6"  >
                  <img src="../assets/images/single.png" class="sample-cover" alt="" @click="download('https://taizhicn-com.oss-cn-beijing.aliyuncs.com/download/太智联合薪酬报告--线下岗位版.doc','薪酬报告单岗位样本报告')">                 
                </el-col>
                <el-col :span="6" >
                  <img src="../assets/images/all-industry.png" class="sample-cover" alt="" @click="download('https://taizhicn-com.oss-cn-beijing.aliyuncs.com/download/太智联合薪酬报告样本--线下行业版.doc','薪酬报告行业样本报告')">                
                </el-col>            
              </el-row>
            </div>
          </div>   
        </div>        
      </div>     
    </el-container>
  </div>
</template>
<script>
import helpers from '../helper';
import industrys from '../utils/industrys.js';
import citys from '../utils/citys.js';
import echarts from 'echarts';
import geoJson from '../utils/data-1517645039291-B1vgpymUz.json';
import customed from '../utils/customed';
import analyzeOptions from '../utils/analyze';
import geoCoordMap from '../utils/geoCoordMap';
import { fetchPost,fetchGet } from '../utils/http';
import { setTimeout } from 'timers';
export default {
  name: "search",
  data() {
    return {
      lazyload:false,
      industrys:industrys,
      citys:citys,
      city:"待选择",
      industry:"待选择",
      property:"民营",
      post:"待选择",
      chart1:{},
      ageChart:{},
      analyzeChart:{},
      aresChart:{},
      deps:[],      
      posts:[],
      showDepts:false,
      showDeptsLoading:false,
      showPosts:false,
      showPostsLoading:false,
      options:{},
      ageOptions:{},
      koujing:"月总收入",
      resultsLoading:false,
      resultsShow:false,
      // diffrience1 :[],
      // low1 : [],
      // diffrience2 :[],
      // low2 :[],
      analyzeOptions:{},
      aresQuantile:'50%分位',
      aresKoujing:'月总收入',
      aresOption:{},
    };
  },
  methods: {
    handleSelect(key, keyPath) {
      //console.log(key, keyPath);
    },
    download(path,name){
      var a = document.createElement('a');
      a.setAttribute('href', path);
      a.setAttribute('target', '_blank');
      a.setAttribute('id', 'startTelMedicine');
      // 防止反复添加
      if(document.getElementById('startTelMedicine')) {
        document.body.removeChild(document.getElementById('startTelMedicine'));
      }
      document.body.appendChild(a);
      a.click();
    },
    selectIndustry(industryName){
      this.industry = industryName;
      this.posts = [];
      this.post = '待选择';
      this.showPosts = false;      
      this.showDeptsLoading = true;
      let _this = this;
      this.$http.post(
        helpers.BASE_URL + "/api/home/index/getDeps",
        { industry : this.industry }
      )
      .then(function(res){
        _this.deps = res.data.data.deps;
        _this.showDepts = true;
        _this.showDeptsLoading = false;
      })
    },
    selectProperty(){
      this.doSearch();
    },
    selectPost(dep){
      this.showPostsLoading = true;
      let _this = this;      
      this.$http.post(
        helpers.BASE_URL + "/api/home/index/getPosts",
        { industry : this.industry, dep: dep}
      )
      .then(function(res){
        _this.posts = res.data.data.posts;
        _this.showPosts = true;
        _this.showPostsLoading = false;
      })
    },
    handleClickPost(post){
      this.post = post;
      this.doSearch();
    },
    convertData(data) {
      var res = [];
      for (var i = 0; i < data.length; i++) {
          var geoCoord = geoCoordMap[data[i].name];
          if (geoCoord) {
              res.push({
                  name: data[i].name,
                  value: geoCoord.concat(data[i].value)
              });
          }
      }
      return res;
    },
    //主图表切换口径
    changeKoujing(koujing){
      if(this.city == '待选择' || this.property == '待选择' || this.post == '待选择'){
        return;
      }
      this.koujing = koujing;
      //如果已登录切换主图口径
      if(sessionStorage.getItem('token') == null){
        this.resultsLoading = true;
        let _this = this;
        this.$http.post(
          helpers.BASE_URL + '/api/home/index/switchMainKoujing',
          {
            industry:this.industry,
            city:this.city,
            property:this.property,
            post:this.post,
            koujing:this.koujing
          }
        )
        .then(function(res){ 
          _this.resultsLoading = false;           
          if(res.data.code ===1){         
            let mainData = Object.values(res.data.data.mainData.data);
            _this.koujing = res.data.data.mainData.koujing;
            _this.aresKoujing = res.data.data.mainData.koujing;
            let data = [];
            //重新绘制主图表
            mainData.map(e => data.push(parseInt(e)));
            _this.options.series[0].data = data;
            _this.chart1.setOption(_this.options);
            //重新绘制地图图表            
            _this.aresOption.dataRange.splitList = res.data.data.areaData.splitList;
            _this.aresOption.series[0].data = _this.convertData(res.data.data.areaData.data);                                      
            _this.aresChart.setOption(_this.aresOption);
            //重新绘制职能,行业图表
            _this.analyzeOptions.series[0].data = res.data.data.analyzeData.data.low1;
            _this.analyzeOptions.series[1].data = res.data.data.analyzeData.data.low2;
            _this.analyzeOptions.series[2].data = res.data.data.analyzeData.data.diff1;
            _this.analyzeOptions.series[3].data = res.data.data.analyzeData.data.diff2;
            _this.analyzeChart.setOption(_this.analyzeOptions);
          }
        });
      }
      //如果已登录切换主图口径
      if(sessionStorage.getItem('token') != null){
      this.resultsLoading = true;
      let _this = this;
      fetchPost('/api/home/api/switchMainKoujingByToken',
          {
            industry:this.industry,
            city:this.city,
            property:this.property,
            post:this.post,
            koujing:this.koujing
          }
        )
        .then(function(res){ 
          _this.resultsLoading = false;           
          if(res.data.code ===1){     
            let mainData = Object.values(res.data.data.mainData.data);
            _this.koujing = res.data.data.mainData.koujing;
            _this.aresKoujing = res.data.data.mainData.koujing;
            let data = [];
            //重新绘制主图表
            mainData.map(e => data.push(parseInt(e)));
            _this.options.series[0].data = data;
            _this.chart1.setOption(_this.options);
            //重新绘制地图图表            
            _this.aresOption.dataRange.splitList = res.data.data.areaData.splitList;
            _this.aresOption.series[0].data = _this.convertData(res.data.data.areaData.data);                                      
            _this.aresChart.setOption(_this.aresOption);
            //重新绘制职能,行业图表
            _this.analyzeOptions.series[0].data = res.data.data.analyzeData.data.low1;
            _this.analyzeOptions.series[1].data = res.data.data.analyzeData.data.low2;
            _this.analyzeOptions.series[2].data = res.data.data.analyzeData.data.diff1;
            _this.analyzeOptions.series[3].data = res.data.data.analyzeData.data.diff2;
            _this.analyzeChart.setOption(_this.analyzeOptions);
          }else{
            return _this.$message.error(res.data.msg)
          }
        });
      }
    },
    changeareKoujing(koujing){
      this.aresKoujing = koujing;
      if(this.city == '待选择' || this.property == '待选择' || this.post == '待选择'){
        return;
      }    
      this.resultsLoading = true;
      let _this = this;
      this.$http.post(
        helpers.BASE_URL + '/api/home/index/switchAreaKoujing',
        {
          industry:this.industry,
          city:this.city,
          property:this.property,
          post:this.post,
          koujing:this.aresKoujing,
          percentile:this.aresQuantile
        }
      )
      .then(function(res){ 
        _this.resultsLoading = false;           
        if(res.data.code ===1){                                
          //重新绘制地图图表            
          _this.aresOption.dataRange.splitList = res.data.data.areaData.splitList;
          _this.aresOption.series[0].data = _this.convertData(res.data.data.areaData.data);                                      
          _this.aresChart.setOption(_this.aresOption);           
        }
      });  
    },
    changeQuantile(quantile){
      this.aresQuantile = quantile;
      if(this.city == '待选择' || this.property == '待选择' || this.post == '待选择'){
        return;
      }

      this.resultsLoading = true;
      let _this = this;
      this.$http.post(
        helpers.BASE_URL + '/api/home/index/switchAreaPercentile',
        {
          industry:this.industry,
          city:this.city,
          property:this.property,
          post:this.post,
          koujing:this.aresKoujing,
          percentile:this.aresQuantile
        }
      )
      .then(function(res){ 
        _this.resultsLoading = false;           
        if(res.data.code ===1){                                
          //重新绘制地图图表
          _this.aresOption.dataRange.splitList = res.data.data.areaData.splitList;
          _this.aresOption.series[0].data = _this.convertData(res.data.data.areaData.data);                                      
          _this.aresChart.setOption(_this.aresOption);           
        }
      });
    },
    selectCity(cityName){      
      this.city = cityName;
      this.doSearch();
    },
    doSearch(){
      //判断条件是否选择完整
      if(this.city == "待选择" || this.industry == "待选择" || this.post == "待选择"){
        return false;
      }
      
      //用户未登录
      if(sessionStorage.getItem('token') == null){
        //未登录检查counter是否查询过
        if(localStorage.getItem('counter') == null){
          this.resultsLoading = true;
          let _this = this;
          this.$http.post(
            helpers.BASE_URL + '/api/home/index/doSearch',
            {
              industry:this.industry,
              city:this.city,
              property:this.property,
              post:this.post
            }
          )
          .then(function(res){ 
            _this.resultsLoading = false;           
            if(res.data.code ===1){
              localStorage.setItem('counter',1);
              //console.log(res.data.data);
              let mainData = Object.values(res.data.data.mainData.data);
              let data = [];
              //重新绘制主图表
              mainData.map(e => data.push(parseInt(e)));
              _this.options.series[0].data = data;
              _this.chart1.setOption(_this.options);
              //重新绘制地图图表            
              _this.aresOption.dataRange.splitList = res.data.data.areaData.splitList;
              _this.aresOption.series[0].data = _this.convertData(res.data.data.areaData.data);                                      
              _this.aresChart.setOption(_this.aresOption);
              //重新绘制职能,行业图表
              _this.analyzeOptions.series[0].data = res.data.data.analyzeData.data.low1;
              _this.analyzeOptions.series[1].data = res.data.data.analyzeData.data.low2;
              _this.analyzeOptions.series[2].data = res.data.data.analyzeData.data.diff1;
              _this.analyzeOptions.series[3].data = res.data.data.analyzeData.data.diff2;
              _this.analyzeChart.setOption(_this.analyzeOptions);
            }
          });                    
        }else{          
          //未登录且免费次数已用完
          this.$message({
            message:'游客只能使用一次，请登录后继续使用！',
            type:'warning'
          });
          this.$router.push('/login');
        }        
      }

      //已登录用户查询
      if(sessionStorage.getItem('token') != null){
        this.resultsLoading = true;
        let _this = this;
        fetchPost('/api/home/api/doSearchUseToken',{
          industry:this.industry,
          city:this.city,
          property:this.property,
          post:this.post
        })
        .then((res)=>{
          // //console.log(res.data);
          _this.resultsLoading = false;

          if( res.data.code === 10002 ){
            _this.$message({
              message:res.data.msg,
              type:'warning'
            });
            _this.$router.push({name:'member-center', params: {activeIndex:'charge'}});
          }
          // if( res.data.code === 10001 ){
          //   _this.$notify({
          //     title:'提示',
          //     message:res.data.msg,
          //     type:'warning'
          //   });
          //   _this.$router.push({name:'member-center',params:{activeIndex:'charge'}});
          // }
          if( res.data.code === 10003 ){
            _this.$message({
              message:res.data.msg,
              type:'warning'
            });
            this.$router.push({name:'member-center', params: {activeIndex:'charge'}})
          }
          if( res.data.code === 1 ){
            let mainData = Object.values(res.data.data.mainData.data);
            let data = [];
            this.koujing = res.data.data.mainData.koujing;
            this.aresKoujing = res.data.data.mainData.koujing;
            //重新绘制主图表
            mainData.map(e => data.push(parseInt(e)));
            this.options.series[0].data = data;
            this.chart1.setOption(this.options);
            //重新绘制地图图表            
            this.aresOption.dataRange.splitList = res.data.data.areaData.splitList;
            this.aresOption.series[0].data = this.convertData(res.data.data.areaData.data);                                      
            this.aresChart.setOption(this.aresOption);
            //重新绘制职能,行业图表
            this.analyzeOptions.series[0].data = res.data.data.analyzeData.data.low1;
            this.analyzeOptions.series[1].data = res.data.data.analyzeData.data.low2;
            this.analyzeOptions.series[2].data = res.data.data.analyzeData.data.diff1;
            this.analyzeOptions.series[3].data = res.data.data.analyzeData.data.diff2;
            this.analyzeChart.setOption(this.analyzeOptions);
          }
        });
      }
    },
    initChart() {
      echarts.registerTheme('customed', customed)
      this.chart1 = echarts.init(this.$refs.myEchart1,"customed");
      // this.ageChart = echarts.init(this.$refs.age,"customed");
      this.analyzeChart = echarts.init(this.$refs.analyze,"customed");
      this.aresChart = echarts.init(this.$refs.aresChart,"customed");

      this.ageOptions = {
        backgroundColor: '#ffffff',
        title: {
            text: '岗位年龄分布',
            left: 'center',
            top: 0,
            textStyle: {
                color: '#ccc'
            }
        },
        tooltip : {
            trigger: 'item',
            formatter: "{a} <br/>{b} : ({d}%)"
        },
        visualMap: {
            show: false,
            min: 80,
            max: 600,
            inRange: {
                colorLightness: [0, 1]
            }
        },
        series : [
            {
                name:'岗位年龄分布',
                type:'pie',
                radius : '55%',
                center: ['50%', '54%'],
                data:[
                    {value:300, name:'25岁以下'},
                    {value:310, name:'25岁到29岁'},
                    {value:274, name:'30岁到39岁'},
                    {value:235, name:'40岁到49岁'},
                    {value:400, name:'50岁以上'}
                ].sort(function (a, b) { return a.value - b.value; }),
                roseType: 'radius',
                label: {
                    normal: {
                        textStyle: {
                            color: 'rgba(11, 200, 244, 1)'
                        }
                    }
                },
                labelLine: {
                    normal: {
                        lineStyle: {
                            color: 'rgba(89, 218, 247, 1)'
                        },
                        smooth: 0.2,
                        length: 10,
                        length2: 20
                    }
                },
                itemStyle: {
                    normal: {
                        color: '#0bc8f4',
                        shadowBlur: 200,
                        shadowColor: 'rgba(89, 218, 247, 1)'
                    }
                },

                animationType: 'scale',
                animationEasing: 'elasticOut',
                animationDelay: function (idx) {
                    return Math.random() * 200;
                }
            }
        ]
      };
      this.options = {
        xAxis: {
          type: 'category',
          data: ['10%分位', '25%分位', '50%分位', '75%分位', '90%分位']
        },
        yAxis : [
          {
            type : 'value',
            axisLabel : {
              formatter: '{value}元'
            }
          }
        ],
        grid:{
          x:80,
        },
        legend: {
          data:['月总收入']
        },
        tooltip : {
          trigger: 'axis'
        },
        series: [{
          data: [0, 0, 0, 0, 0],
          type: 'line',
          lineStyle:{
            width:3
          },
          smooth: true
        }]
      };
      echarts.registerMap('china', geoJson);
      this.aresOption = {
        tooltip: {
            trigger: 'item',
            formatter: function(params) {
                return params.name + ' : ' + params.value[2];
            }
        },       
        geo: {
            map: 'china',
            roam: false,
            zoom:1.2,
            label: {
                emphasis: {
                    show: false
                }
            },            
        },
        dataRange: {
            x: 'left',            
            y: 'bottom',
            splitList: [{   
                    start:6422,                 
                    end:6424,
                    label:'一线城市'
                },
                {
                    start: 5376,
                    end:5378,
                    label:'二线城市'
                },
                {
                    start: 5021,
                    end:5023,
                    label:'三线城市'
                },
                {
                    start: 4524,
                    end:4526,
                    label:'四线城市'
                },
            ],
            color: ['#0BC8F4', '#0b9ff4', '#0b68f4','#360bf4']
        },

        series : [
            {                
                type: 'effectScatter',
                coordinateSystem: 'geo',
                data: this.convertData([]),
                label: {
                    normal: {
                        formatter: '{b}',
                        position: 'right',
                        show: false
                    },
                    emphasis: {
                        show: true
                    }
                },
                
            },
            
        ]
      }; 
      
      this.chart1.setOption(this.options);
      // this.ageChart.setOption(this.ageOptions);
      this.analyzeChart.setOption(analyzeOptions);
      this.aresChart.setOption(this.aresOption);
    }
  },
  created(){   
    setTimeout(()=>{
      this.lazyload = true;   
    },100)
  },
  mounted(){
    this.analyzeOptions = analyzeOptions;
    setTimeout(()=>{
      this.initChart();
    },100)
  }
};
</script>
<style scoped>
.home {
  background-color: #f4f4f4;
}
.content-wrap{
  width: 100%;
  margin-top: 60px; 
}
.condition{
  background-color: #ffffff;
  margin: 20px 100px;
  padding: 20px;
  border-radius: 10px;
}
.condition-checked{
  margin: 5px 6px 0 0;
  padding: 2px 5px ;
  float: left;
  word-wrap:break-word;
}
.condition-row{
  margin-bottom: 4px;
}
.condition-head{
  font-size: 14px;
  margin-right: 40px;
  display: inline-block;
  width: 80px;
  text-align: right;
}
.el-dropdown-link {
  cursor: pointer;
  color: #939393;
}
.el-dropdown-link:hover{
  color: #0bc8f4!important;
}
.el-dropdown-menu__item{
  line-height: 24px;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.results{
  margin: 0 100px 20px 100px;
  background-color: #ffffff;
  padding: 40px 60px;
  border-radius: 10px;
}
.deps{
  font-size: 14px;
  color: #939393;
  cursor: pointer;
}
.deps:hover{
  background-color:#0bc8f4!important;
  color: #ffffff;
}
.el-divider--horizontal {
  margin: 10px 0;
}
.expirience-item{
  margin-top: 34px;
  font-size: 12px;
  color: #a3a5b0;
}
.sample-cover{
  border-radius: 10px;
  cursor: pointer;
  width: 100%;
}
</style>

